import { AppealStatus } from '@/schemas/appeals.schema.ts'
import Badge, { ColorType } from '@/common/components/Badge.tsx'
import { ApplicationStatusWithSubStatus } from '@/queries/family_applications/requests'
import { ProviderApplicationStatus } from '@/schemas/provider.schema'

export type ApplicationStatusBadgeProps = {
  status:
    | ApplicationStatusWithSubStatus
    | AppealStatus
    | ProviderApplicationStatus
    | 'Invitation Sent'
  className?: string
}

export default function ApplicationStatusBadge({
  status,
  className,
}: ApplicationStatusBadgeProps) {
  let color: ColorType
  switch (status) {
    case 'Invited':
    case 'V1 Invited':
    case 'ClassWallet Renewal':
    case 'SoftPoint Renewal':
    case 'Appeal In Committee':
    case 'Appeal In Committee - Vote Started':
    case 'Invitation Sent':
      color = 'Informative'
      break
    case 'Pending':
    case 'Appeal':
    case 'In Progress':
    case 'Awaiting Documentation':
    case 'Pending Review':
    case 'Wait Listed':
    case 'Escalated':
    case 'Under Review':
    case 'Appeal In Committee - No Consensus':
    case 'Appeal In Review':
    case 'Application In Progress':
      color = 'Notice'
      break
    //case 'Appeal Accepted':
    case 'Eligible':
    case 'Complete':
    case 'Approved':
    case 'Awarded':
    case 'Funded':
    case 'Resolved':
    case 'Selected':
    case 'Application Submitted':
    case 'Application Accepted':
      color = 'Positive'
      break
    case 'Incomplete':
    case 'In Review':
    case 'Ineligible':
    case 'Ineligible (Duplicate)':
    case 'Age Phase Out':
    case 'Closed':
    case 'Denied':
    case 'Withdraw':
    case 'Application Rejected':
    case 'Withdrawn':
      color = 'Negative'
      break
    default:
      color = 'Neutral'
  }
  return (
    <Badge semanticColor={color} className={className}>
      {status}
    </Badge>
  )
}
